import React from 'react';
import { useParams } from 'react-router-dom';
import useFetchJSONContent from '../../hooks/use-fetch-json';
import { ButtonsBox, ButtonWrapper, NextButton, PreviousButton } from './styles';

import Chevron from '../../assets/icons/chevron';
import { IPage } from '../side-bar/sections';

export default function NavigationButtons() {
  const { subject, page, section } = useParams();

  if (!subject || !page) return <>Não foi possivel encontrar essa página</>;

  const data = useFetchJSONContent<IPage[]>('content/html/pageMetadata.json', 'sections');

  if (!data || data.length === 0) {
    return null;
  }

  const currentPage = data.find((item) => item.slug === `${subject}/${page}${section ? `/${section}` : ''}`);

  if (!currentPage) {
    return null;
  }

  const isFirstPage = currentPage.id === 1;
  const isLastPage = currentPage.id === data.length;
  const nextPage = data.find((item) => item.id === currentPage.id + 1);
  const previousPage = data.find((item) => item.id === currentPage.id - 1);
  const getPath = (path: string) => `/${path}`;

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ButtonsBox $isfirst={isFirstPage} $subject="">
      {(!isFirstPage && previousPage) && (
        <ButtonWrapper $type="previous">
          <PreviousButton to={getPath(previousPage.slug)} $subject="portuguese">
            <Chevron />
          </PreviousButton>
        </ButtonWrapper>
      )}

      {(!isLastPage && nextPage) && (
        <ButtonWrapper $type="next">
          <NextButton to={getPath(nextPage.slug)} $subject="portuguese">
            <Chevron />
          </NextButton>
        </ButtonWrapper>
      )}
    </ButtonsBox>
  );
}
